import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults, validateParameters } from './../../wayfinder'
import twoFactor from './two-factor'
import password from './password'
import motels from './motels'
import portfolioE55e31 from './portfolio'
import notifications from './notifications'
import otaEvents from './ota-events'
import queue from './queue'
import bookings from './bookings'
import licenseScans from './license-scans'
import roomTypes from './room-types'
import rooms from './rooms'
import roomBlocks from './room-blocks'
import impersonate1fe2a3 from './impersonate'
import users from './users'
import customers from './customers'
import onboardingRequests from './onboarding-requests'
import documents from './documents'
import heroBanners from './hero-banners'
import roles from './roles'
import amenities from './amenities'
import drivingLicenseRegexFormats from './driving-license-regex-formats'
import pricing from './pricing'
import ratePlans from './rate-plans'
import otaRates from './ota-rates'
import invoices from './invoices'
import profitLoss from './profit-loss'
import reports from './reports'
import promotions from './promotions'
import address from './address'
import locations from './locations'
import blog from './blog'
/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:97
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:97
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:97
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:97
* @route '/logout'
*/
const logoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:97
* @route '/logout'
*/
logoutForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

logout.form = logoutForm

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::sso
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:61
* @route '/sso'
*/
export const sso = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sso.url(options),
    method: 'get',
})

sso.definition = {
    methods: ["get","head"],
    url: '/sso',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::sso
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:61
* @route '/sso'
*/
sso.url = (options?: RouteQueryOptions) => {
    return sso.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::sso
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:61
* @route '/sso'
*/
sso.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sso.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::sso
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:61
* @route '/sso'
*/
sso.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: sso.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::sso
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:61
* @route '/sso'
*/
const ssoForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sso.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::sso
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:61
* @route '/sso'
*/
ssoForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sso.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::sso
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:61
* @route '/sso'
*/
ssoForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sso.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

sso.form = ssoForm

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:24
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:24
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:24
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:24
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:24
* @route '/login'
*/
const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:24
* @route '/login'
*/
loginForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Admin/Auth/AuthenticatedSessionController.php:24
* @route '/login'
*/
loginForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

login.form = loginForm

/**
* @see routes/admin.php:69
* @route '/home'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/home',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/admin.php:69
* @route '/home'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see routes/admin.php:69
* @route '/home'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see routes/admin.php:69
* @route '/home'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see routes/admin.php:69
* @route '/home'
*/
const homeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see routes/admin.php:69
* @route '/home'
*/
homeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see routes/admin.php:69
* @route '/home'
*/
homeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

home.form = homeForm

/**
* @see \App\Http\Controllers\Admin\DashboardController::__invoke
* @see app/Http/Controllers/Admin/DashboardController.php:26
* @route '/dashboard'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/dashboard',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\DashboardController::__invoke
* @see app/Http/Controllers/Admin/DashboardController.php:26
* @route '/dashboard'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DashboardController::__invoke
* @see app/Http/Controllers/Admin/DashboardController.php:26
* @route '/dashboard'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DashboardController::__invoke
* @see app/Http/Controllers/Admin/DashboardController.php:26
* @route '/dashboard'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\DashboardController::__invoke
* @see app/Http/Controllers/Admin/DashboardController.php:26
* @route '/dashboard'
*/
const dashboardForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DashboardController::__invoke
* @see app/Http/Controllers/Admin/DashboardController.php:26
* @route '/dashboard'
*/
dashboardForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DashboardController::__invoke
* @see app/Http/Controllers/Admin/DashboardController.php:26
* @route '/dashboard'
*/
dashboardForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

dashboard.form = dashboardForm

/**
* @see \App\Http\Controllers\Admin\PortfolioController::portfolio
* @see app/Http/Controllers/Admin/PortfolioController.php:14
* @route '/portfolio'
*/
export const portfolio = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: portfolio.url(options),
    method: 'get',
})

portfolio.definition = {
    methods: ["get","head"],
    url: '/portfolio',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\PortfolioController::portfolio
* @see app/Http/Controllers/Admin/PortfolioController.php:14
* @route '/portfolio'
*/
portfolio.url = (options?: RouteQueryOptions) => {
    return portfolio.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\PortfolioController::portfolio
* @see app/Http/Controllers/Admin/PortfolioController.php:14
* @route '/portfolio'
*/
portfolio.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: portfolio.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PortfolioController::portfolio
* @see app/Http/Controllers/Admin/PortfolioController.php:14
* @route '/portfolio'
*/
portfolio.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: portfolio.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\PortfolioController::portfolio
* @see app/Http/Controllers/Admin/PortfolioController.php:14
* @route '/portfolio'
*/
const portfolioForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: portfolio.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PortfolioController::portfolio
* @see app/Http/Controllers/Admin/PortfolioController.php:14
* @route '/portfolio'
*/
portfolioForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: portfolio.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\PortfolioController::portfolio
* @see app/Http/Controllers/Admin/PortfolioController.php:14
* @route '/portfolio'
*/
portfolioForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: portfolio.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

portfolio.form = portfolioForm

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
export const bookingCalendar = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bookingCalendar.url(options),
    method: 'get',
})

bookingCalendar.definition = {
    methods: ["get","head","post","put","patch","delete","options"],
    url: '/booking-calendar',
} satisfies RouteDefinition<["get","head","post","put","patch","delete","options"]>

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
bookingCalendar.url = (options?: RouteQueryOptions) => {
    return bookingCalendar.definition.url + queryParams(options)
}

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
bookingCalendar.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bookingCalendar.url(options),
    method: 'get',
})

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
bookingCalendar.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: bookingCalendar.url(options),
    method: 'head',
})

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
bookingCalendar.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bookingCalendar.url(options),
    method: 'post',
})

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
bookingCalendar.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: bookingCalendar.url(options),
    method: 'put',
})

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
bookingCalendar.patch = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: bookingCalendar.url(options),
    method: 'patch',
})

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
bookingCalendar.delete = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: bookingCalendar.url(options),
    method: 'delete',
})

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
bookingCalendar.options = (options?: RouteQueryOptions): RouteDefinition<'options'> => ({
    url: bookingCalendar.url(options),
    method: 'options',
})

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
const bookingCalendarForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bookingCalendar.url(options),
    method: 'get',
})

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
bookingCalendarForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bookingCalendar.url(options),
    method: 'get',
})

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
bookingCalendarForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bookingCalendar.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
bookingCalendarForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bookingCalendar.url(options),
    method: 'post',
})

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
bookingCalendarForm.put = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bookingCalendar.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
bookingCalendarForm.patch = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bookingCalendar.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
bookingCalendarForm.delete = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bookingCalendar.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \Illuminate\Routing\RedirectController::__invoke
* @see vendor/laravel/framework/src/Illuminate/Routing/RedirectController.php:19
* @route '/booking-calendar'
*/
bookingCalendarForm.options = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bookingCalendar.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'OPTIONS',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

bookingCalendar.form = bookingCalendarForm

/**
* @see \Lab404\Impersonate\Controllers\ImpersonateController::impersonate
* @see vendor/lab404/laravel-impersonate/src/Controllers/ImpersonateController.php:32
* @route '/impersonate/take/{id}/{guardName?}'
*/
export const impersonate = (args: { id: string | number, guardName?: string | number } | [id: string | number, guardName: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: impersonate.url(args, options),
    method: 'get',
})

impersonate.definition = {
    methods: ["get","head"],
    url: '/impersonate/take/{id}/{guardName?}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Lab404\Impersonate\Controllers\ImpersonateController::impersonate
* @see vendor/lab404/laravel-impersonate/src/Controllers/ImpersonateController.php:32
* @route '/impersonate/take/{id}/{guardName?}'
*/
impersonate.url = (args: { id: string | number, guardName?: string | number } | [id: string | number, guardName: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            id: args[0],
            guardName: args[1],
        }
    }

    args = applyUrlDefaults(args)

    validateParameters(args, [
        "guardName",
    ])

    const parsedArgs = {
        id: args.id,
        guardName: args.guardName,
    }

    return impersonate.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace('{guardName?}', parsedArgs.guardName?.toString() ?? '')
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \Lab404\Impersonate\Controllers\ImpersonateController::impersonate
* @see vendor/lab404/laravel-impersonate/src/Controllers/ImpersonateController.php:32
* @route '/impersonate/take/{id}/{guardName?}'
*/
impersonate.get = (args: { id: string | number, guardName?: string | number } | [id: string | number, guardName: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: impersonate.url(args, options),
    method: 'get',
})

/**
* @see \Lab404\Impersonate\Controllers\ImpersonateController::impersonate
* @see vendor/lab404/laravel-impersonate/src/Controllers/ImpersonateController.php:32
* @route '/impersonate/take/{id}/{guardName?}'
*/
impersonate.head = (args: { id: string | number, guardName?: string | number } | [id: string | number, guardName: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: impersonate.url(args, options),
    method: 'head',
})

/**
* @see \Lab404\Impersonate\Controllers\ImpersonateController::impersonate
* @see vendor/lab404/laravel-impersonate/src/Controllers/ImpersonateController.php:32
* @route '/impersonate/take/{id}/{guardName?}'
*/
const impersonateForm = (args: { id: string | number, guardName?: string | number } | [id: string | number, guardName: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: impersonate.url(args, options),
    method: 'get',
})

/**
* @see \Lab404\Impersonate\Controllers\ImpersonateController::impersonate
* @see vendor/lab404/laravel-impersonate/src/Controllers/ImpersonateController.php:32
* @route '/impersonate/take/{id}/{guardName?}'
*/
impersonateForm.get = (args: { id: string | number, guardName?: string | number } | [id: string | number, guardName: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: impersonate.url(args, options),
    method: 'get',
})

/**
* @see \Lab404\Impersonate\Controllers\ImpersonateController::impersonate
* @see vendor/lab404/laravel-impersonate/src/Controllers/ImpersonateController.php:32
* @route '/impersonate/take/{id}/{guardName?}'
*/
impersonateForm.head = (args: { id: string | number, guardName?: string | number } | [id: string | number, guardName: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: impersonate.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

impersonate.form = impersonateForm

const admin = {
    login: Object.assign(login, login),
    logout: Object.assign(logout, logout),
    twoFactor: Object.assign(twoFactor, twoFactor),
    sso: Object.assign(sso, sso),
    password: Object.assign(password, password),
    home: Object.assign(home, home),
    motels: Object.assign(motels, motels),
    dashboard: Object.assign(dashboard, dashboard),
    portfolio: Object.assign(portfolio, portfolioE55e31),
    notifications: Object.assign(notifications, notifications),
    otaEvents: Object.assign(otaEvents, otaEvents),
    queue: Object.assign(queue, queue),
    bookings: Object.assign(bookings, bookings),
    bookingCalendar: Object.assign(bookingCalendar, bookingCalendar),
    licenseScans: Object.assign(licenseScans, licenseScans),
    roomTypes: Object.assign(roomTypes, roomTypes),
    rooms: Object.assign(rooms, rooms),
    roomBlocks: Object.assign(roomBlocks, roomBlocks),
    impersonate: Object.assign(impersonate, impersonate1fe2a3),
    users: Object.assign(users, users),
    customers: Object.assign(customers, customers),
    onboardingRequests: Object.assign(onboardingRequests, onboardingRequests),
    documents: Object.assign(documents, documents),
    heroBanners: Object.assign(heroBanners, heroBanners),
    roles: Object.assign(roles, roles),
    amenities: Object.assign(amenities, amenities),
    drivingLicenseRegexFormats: Object.assign(drivingLicenseRegexFormats, drivingLicenseRegexFormats),
    pricing: Object.assign(pricing, pricing),
    ratePlans: Object.assign(ratePlans, ratePlans),
    otaRates: Object.assign(otaRates, otaRates),
    invoices: Object.assign(invoices, invoices),
    profitLoss: Object.assign(profitLoss, profitLoss),
    reports: Object.assign(reports, reports),
    promotions: Object.assign(promotions, promotions),
    address: Object.assign(address, address),
    locations: Object.assign(locations, locations),
    blog: Object.assign(blog, blog),
}

export default admin